import {
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
  UntypedFormArray,
} from '@angular/forms';

export function atLeastOneCompleteConditionValidator() :ValidatorFn {
  return (control :AbstractControl) :ValidationErrors | null => {
    const formArray = control as UntypedFormArray;

    if (formArray.length === 0) {
      return { noConditionsAdded: true };
    }

    const isAtLeastOneComplete = formArray.controls.some((condition) => {
      const field = condition.get('field')?.value;
      const operator = condition.get('operator')?.value;
      const value = condition.get('value')?.value;

      return field && operator && value;
    });

    return isAtLeastOneComplete
      ? null
      : { atLeastOneCompleteConditionRequired: true };
  };
}

export function completeRowConditionValidator() :ValidatorFn {
  return (formArray :AbstractControl) :ValidationErrors | null => {
    const array = formArray as UntypedFormArray;

    for (const group of array.controls) {
      const field = group.get('field')?.value;
      const operator = group.get('operator')?.value;
      const value = group.get('value')?.value;
      const allFilled = field && operator && value;
      const allEmpty = !field && !operator && !value;

      if (!allFilled && !allEmpty) {
        return { incompleteCondition: true };
      }
    }

    return null;
  };
}
